module.exports = __webpack_public_path__ + "static/img/female-bg-tr.6501cd08.png";